import { itemColors } from "~/common/itemColors";
import { AppEntity, AppExtEntity, UnionAppEntity } from "~/normalizr/entities";
import { activityListResx } from "~/resxDist/activityListResx";
import { commonClientResx } from "~/resxDist/commonClientResx";
import { customFieldsResx } from "~/resxDist/customFieldsResx";
import { filtersResx } from "~/resxDist/filtersResx";
import { resourcePlanningResx } from "~/resxDist/resourcePlanningResx";
import { ThumbnailData } from "~/sharedComponents/thumbnails/types";
import { icon } from "../icons";

const issueEntityThumbnailData: ThumbnailData = {
    itemType: "Issue",
    tooltip: commonClientResx.Entity_Issue,
    background: itemColors.Issue.background,
    color: itemColors.Issue.textColor,
};

const riskEntityThumbnailData: ThumbnailData = {
    itemType: "Issue",
    tooltip: commonClientResx.Entity_Issue,
    itemIcon: icon.risk,
    background: itemColors.Risk.background,
    color: itemColors.Risk.textColor,
};

const requestEntityThumbnailData: ThumbnailData = {
    itemType: "Request",
    tooltip: commonClientResx.Entity_Request,
    background: itemColors.Request.background,
    color: itemColors.Request.textColor,
};

const projectEntityThumbnailData: ThumbnailData = {
    itemType: "Project",
    tooltip: commonClientResx.Entity_Project,
    background: itemColors.Project.background,
    color: itemColors.Project.textColor,
};

const projectArchiveEntityThumbnailData: ThumbnailData = {
    itemType: "ProjectArchive",
    tooltip: activityListResx.ProjectArchive,
    itemIcon: icon.archive,
    background: itemColors.ProjectArchive.background,
    color: itemColors.ProjectArchive.textColor,
};

const taskEntityThumbnailData: ThumbnailData = {
    itemType: "Task",
    tooltip: commonClientResx.Entity_Task,
    background: itemColors.Task.background,
    color: itemColors.Task.textColor,
};

const milestoneEntityThumbnailData: ThumbnailData = {
    itemType: "Milestone",
    tooltip: filtersResx.Milestone_Text,
    itemIcon: icon.milestone,
    background: itemColors.Milestone.background,
    color: itemColors.Milestone.textColor,
};

const portfolioEntityThumbnailData: ThumbnailData = {
    itemType: "Portfolio",
    tooltip: commonClientResx.Entity_Portfolio,
    background: itemColors.Portfolio.background,
    color: itemColors.Portfolio.textColor,
    itemIcon: icon.case,
};

const customerEntityThumbnailData: ThumbnailData = {
    itemType: "Customer",
    tooltip: commonClientResx.Entity_Customer,
    background: itemColors.Customer.background,
    color: itemColors.Customer.textColor,
    itemIcon: icon.customer,
};

const customFieldEntityThumbnailData: ThumbnailData = {
    itemType: "CustomFields",
    tooltip: commonClientResx.custom_field_label,
    itemIcon: icon.custom_field,
    size: "default",
};

const customFormEntityThumbnailData: ThumbnailData = {
    itemType: "CustomForm",
    tooltip: commonClientResx.custom_form_label,
    itemIcon: icon.forms,
    size: "default",
};

const jobRoleEntityThumbnailData: ThumbnailData = {
    itemType: "JobRole",
    tooltip: commonClientResx.Entity_JobRole,
    background: itemColors.JobRole.background,
    color: itemColors.JobRole.textColor,
    itemIcon: icon.job_role,
};

const otherProjectsEntityThumbnailData: ThumbnailData = {
    itemType: "Project",
    tooltip: resourcePlanningResx.other_projects_label,
    color: itemColors.OtherProjects.textColor,
    background: itemColors.OtherProjects.background,
};

const withoutPortfolioEntityThumbnailData: ThumbnailData = {
    itemType: "Portfolio",
    tooltip: customFieldsResx.no_portfolio,
    background: itemColors.WithoutPortfolio.background,
    color: itemColors.WithoutPortfolio.textColor,
    itemIcon: icon.case,
};

const otherPortfolioEntityThumbnailData: ThumbnailData = {
    itemType: "Portfolio",
    tooltip: customFieldsResx.other_portfolios,
    background: itemColors.WithoutPortfolio.background,
    color: itemColors.WithoutPortfolio.textColor,
    itemIcon: icon.case,
};

const entityThumbnails: PartialRecord<UnionAppEntity, ThumbnailData> = {
    [AppEntity.Project]: projectEntityThumbnailData,
    [AppExtEntity.ProjectArchive]: projectArchiveEntityThumbnailData,
    [AppEntity.Task]: taskEntityThumbnailData,
    [AppEntity.Issue]: issueEntityThumbnailData,
    [AppEntity.Portfolio]: portfolioEntityThumbnailData,
    [AppEntity.Request]: requestEntityThumbnailData,
    [AppEntity.Customer]: customerEntityThumbnailData,
    [AppExtEntity.Milestone]: milestoneEntityThumbnailData,
    [AppExtEntity.JobRole]: jobRoleEntityThumbnailData,
    [AppExtEntity.OtherProjects]: otherProjectsEntityThumbnailData,
    [AppExtEntity.WithoutPortfolio]: withoutPortfolioEntityThumbnailData,
    [AppExtEntity.OtherPortfolios]: otherPortfolioEntityThumbnailData,
    [AppExtEntity.CustomField]: customFieldEntityThumbnailData,
    [AppExtEntity.CustomForm]: customFormEntityThumbnailData,
};

export {
    customerEntityThumbnailData,
    entityThumbnails,
    issueEntityThumbnailData,
    jobRoleEntityThumbnailData,
    milestoneEntityThumbnailData,
    otherProjectsEntityThumbnailData,
    portfolioEntityThumbnailData,
    projectArchiveEntityThumbnailData,
    projectEntityThumbnailData,
    requestEntityThumbnailData,
    riskEntityThumbnailData,
    taskEntityThumbnailData,
    customFieldEntityThumbnailData,
};
